import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            We offer a variety of services to make you look your absolute best. Contact us at <b>415-641-1138</b> to schedule an appointment today!
          </p>
        </div>
       <div className="row">
  {props.data
    ? props.data.map((d, i) => (
        <div key={`${d.name}-${i}`} className="col-md-12">
          <i className={d.icon}></i>
          <div className="service-desc">
            <h3>{d.name}</h3>
            {Array.isArray(d.text) ? (
              d.text.map((paragraph, idx) => <p key={idx}>{paragraph}</p>)
            ) : (
              <p>{d.text}</p>
            )}
          </div>
        </div>
      ))
    : "loading"}
</div>
      </div>
    </div>
  );
};
